import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './par-country.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParCountryDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const parCountryEntity = useAppSelector(state => state.parCountry.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="parCountryDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.parCountry.detail.title">ParCountry</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{parCountryEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.parCountry.code">Code</Translate>
            </span>
          </dt>
          <dd>{parCountryEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.parCountry.name">Name</Translate>
            </span>
          </dt>
          <dd>{parCountryEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.parCountry.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{parCountryEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.parCountry.nameFrench">nameFrench</Translate>
            </span>
          </dt>
          <dd>{parCountryEntity.nameFrench}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.parCountry.status">Status</Translate>
            </span>
          </dt>
          <dd>{parCountryEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/par-country" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/par-country/${parCountryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParCountryDetail;
